(function() {
    var sections = document.querySelectorAll('.big-bold-section');
    if (!sections.length) return;

    sections.forEach(function(section) {
      var counters = section.querySelectorAll('.big-bold__count');
      if (!counters.length) return;

      var animated = false;

      function animateCounters() {
        if (animated) return;
        animated = true;

        counters.forEach(function(counter) {
          var targetAttr = counter.getAttribute('data-target-count') || '0';
          var target = parseInt(targetAttr.replace(/[^0-9]/g, ''), 10);
          if (isNaN(target)) target = 0;

          var speedAttr = counter.getAttribute('data-count-speed');
          var duration = parseInt(speedAttr, 10);
          if (isNaN(duration) || duration <= 0) {
            duration = 2500;
          }

          var start = null;

          function step(timestamp) {
            if (!start) start = timestamp;
            var rawProgress = Math.min((timestamp - start) / duration, 1);
            var value = Math.floor(rawProgress * target);
            counter.textContent = value + '%';
            if (rawProgress < 1) {
              window.requestAnimationFrame(step);
            } else {
              counter.textContent = target + '%';
            }
          }

          window.requestAnimationFrame(step);
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries, obs) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              animateCounters();
              obs.disconnect();
            }
          });
        }, { threshold: 0.3 });

        observer.observe(section);
      } else {
        window.addEventListener('load', function() {
          setTimeout(animateCounters, 500);
        });
      }
    });
  })();